import { render, staticRenderFns } from "./VerticalBanner.vue?vue&type=template&id=6f9195fb&"
import script from "./VerticalBanner.vue?vue&type=script&lang=js&"
export * from "./VerticalBanner.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports